import { makeStyles } from '@material-ui/core';
import paradigmWordmark from './assets/paradigm-wordmark.png';

const useStyles = makeStyles({
  img: {
    width: 168,
    height: 'auto',
    display: 'block',
  },
});

export const LogoFull = () => {
  const classes = useStyles();

  return <img className={classes.img} src={paradigmWordmark} alt="Paradigm" />;
};
